export default function Logo({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <rect width="40" height="40" rx="10" fill="#1c2b25" />
      <path d="M20 8L7 18V33H16V25H24V33H33V18L20 8Z" fill="#7ecfb0" />
      <rect x="17" y="25" width="6" height="8" fill="#1c2b25" opacity="0.4" />
    </svg>
  );
}
